var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"30px"}},[_c('tabla',{attrs:{"Titulo":"Tipo de Contrato","Cabecera":_vm.Cabecera,"Items":_vm.Items,"Excel":false,"Crear":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }